import SubcategoryPage from '@/components/template/SubcategoryPage';

const MetalUmivalniki = () => {
  const products = [
    {
      title: "Metal Umivalnik Bakreni",
      imageSrc: "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80",
      url: "/umivalniki/metal/bakreni"
    },
    {
      title: "Metal Umivalnik Medenina",
      imageSrc: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?auto=format&fit=crop&q=80",
      url: "/umivalniki/metal/medenina"
    },
    {
      title: "Metal Umivalnik Nerjaveče Jeklo",
      imageSrc: "https://images.unsplash.com/photo-1600566752427-25ef8fb4e018?auto=format&fit=crop&q=80",
      url: "/umivalniki/metal/nerjavece-jeklo"
    },
    {
      title: "Metal Umivalnik Industrial",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/umivalniki/metal/industrial"
    },
    {
      title: "Metal Umivalnik Modern",
      imageSrc: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80",
      url: "/umivalniki/metal/modern"
    },
    {
      title: "Metal Umivalnik Premium",
      imageSrc: "https://images.unsplash.com/photo-1600566752610-111d521cf1de?auto=format&fit=crop&q=80",
      url: "/umivalniki/metal/premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Metal Umivalniki"
      description="Raziskujte našo kolekcijo vzdržljivih in elegantnih kovinskih umivalnikov, ki združujejo industrijski šarm z moderno estetiko. Izbirajte med bakrom, medenino, nerjavečim jeklom in drugimi kovinami za trpežno in vizualno osupljivo nadgradnjo vaše kopalnice."
      heroImage="https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default MetalUmivalniki;